<template>
  <div class="loading">
    Loading data...
  </div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style scoped>
  .loading {
    font-size: 16px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }  
</style>



// WEBPACK FOOTER //
// Loading.vue?66b26e92